import React from 'react';

import { IconButton } from '@eika/button';
import { IconTypes } from '@eika/icon';

import useTranslation from '../../../../hooks/useTranslation';
import { EikaModal } from '../../../EikaModal';
import FocusSubModal from '../../../transaction/MultiformWrapper/FocusSubModal';

import './CalendarModal.scss';

type CalendarModalProps = {
    useFocusModal?: boolean;
    open: boolean;
    setOpen: React.Dispatch<boolean>;
    footer?: React.ReactNode;
} & React.PropsWithChildren;

const CalendarModal: React.FC<CalendarModalProps> = ({ useFocusModal = false, children, footer, open, setOpen }) => {
    const translated = useTranslation();
    if (useFocusModal) {
        return (
            <FocusSubModal open={open} onClose={() => setOpen(false)} className="calendar-modal__focus">
                <div className="focus-modal__wrapper">
                    <div>
                        <div className="focus-modal__action-wrapper">
                            <IconButton
                                icon={IconTypes.BACK}
                                onClick={() => setOpen(false)}
                                screenReaderText={translated.goBack}
                            />
                        </div>
                        <div className="focus-modal__content-wrapper">
                            <h2 className="focus-modal__title">{translated.dateField.title}</h2>
                            {children}
                        </div>
                    </div>
                    {footer ? <div className="focus-modal__footer">{footer}</div> : null}
                </div>
            </FocusSubModal>
        );
    }
    return (
        <EikaModal open={open} setOpen={setOpen} footerContent={footer} title={translated.dateField.title} size="wide">
            {children}
        </EikaModal>
    );
};

export default CalendarModal;
